import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(3),
    paddingTop: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.grey[200]}`,
  },
  standalone: {
    marginTop: 0,
    paddingTop: 0,
    borderTop: 'none',
  },
  titleWrapper: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: theme.spacing(1),
  },
  title: {
    fontSize: 14,
    fontWeight: 600,
    color: theme.palette.text.primary,
    whiteSpace: 'nowrap',
  },
  description: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
  },
  fieldsRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
  },
  controlsGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    marginLeft: 'auto',
  },
  unlimitedLabel: {
    marginRight: 0,
  },
  amountField: {
    width: 120,
  },
  amountHelperText: {
    overflow: 'visible',
    textOverflow: 'unset',
    whiteSpace: 'normal',
  },
  unitField: {
    width: 160,
  },
}))

export default useStyles
